import React from 'react';
import PropTypes from 'prop-types';

import './DevicesTableRow.css';

const DevicesTableRow = ({
	isActive,
	isPrimary,
	deviceName,
	batteryLevel,
	isCharging,
	batteryTemperature,
	providerName,
	networkType,
	signalStrength
}) => {
	let batteryColor;
	let signalColor;

	if (isActive === true) {
		if (batteryLevel >= 40) {
			batteryColor = '#4cd137';
		} else if (batteryLevel >= 20) {
			batteryColor = '#f39c12';
		} else {
			batteryColor = '#e74c3c';
		}

		if (signalStrength >= 3) {
			signalColor = '#4cd137';
		} else if (signalStrength >= 2) {
			signalColor = '#f39c12';
		} else {
			signalColor = '#e74c3c';
		}
	} else {
		batteryColor = '#333';
		signalColor = '#333';
	}

	const renderSignalBars = () => {
		const bars = [];
		for (let i = 1; i <= 4; i++) {
			bars.push(
				<div
					key={i}
					className="signal-bar"
					style={{
						height: `${i * 3 + 2}px`,
						backgroundColor: i <= signalStrength ? signalColor : '#252525',
						boxShadow: i <= signalStrength ? `0 0 5px ${signalColor}44` : 'none'
					}}
				/>
			);
		}
		return bars;
	};

	let tempClass = 'temp-cool';
	if (batteryTemperature > 41) tempClass = 'temp-critical';
	else if (batteryTemperature > 37) tempClass = 'temp-warn';

	return (
		<tr className="premium-row">
			<td className="premium-cell">
				<div className="device-main-info">
					<span className="device-name-text">{deviceName || 'N/A'}</span>
					{isPrimary && <span className="primary-badge">Primary</span>}
				</div>
			</td>

			<td className="premium-cell">
				{batteryLevel ? (
					<div className="battery-wrapper">
						<div className="battery-percent" style={{ color: isActive ? '#fff' : '#555' }}>
							{batteryLevel}%
							{isCharging && <i className="material-icons" style={{ fontSize: '12px', marginLeft: '2px', color: '#4cd137' }}>flash_on</i>}
						</div>
						<div className="battery-track">
							<div
								className="battery-fill"
								style={{
									width: `${batteryLevel}%`,
									backgroundColor: batteryColor,
									boxShadow: isActive ? `0 0 8px ${batteryColor}44` : 'none'
								}}
							/>
						</div>
					</div>
				) : (
					<span className="value-text">N/A</span>
				)}
			</td>

			<td className="premium-cell">
				{batteryTemperature ? (
					<span className={`temp-pill ${isActive ? tempClass : ''}`}>
						{batteryTemperature}°C
					</span>
				) : (
					<span className="value-text">N/A</span>
				)}
			</td>

			<td className="premium-cell">
				<span className="value-text">{providerName || 'N/A'}</span>
			</td>

			<td className="premium-cell">
				<span className="mono-text" style={{ color: '#888', fontSize: '0.9rem' }}>
					{networkType || 'N/A'}
				</span>
			</td>

			<td className="premium-cell">
				{signalStrength ? (
					<div className="signal-container">
						{renderSignalBars()}
					</div>
				) : (
					<span className="value-text">N/A</span>
				)}
			</td>
		</tr>
	);
};

DevicesTableRow.propTypes = {
	isActive: PropTypes.bool,
	isPrimary: PropTypes.bool,
	deviceName: PropTypes.string,
	batteryLevel: PropTypes.number,
	isCharging: PropTypes.bool,
	batteryTemperature: PropTypes.number,
	providerName: PropTypes.string,
	networkType: PropTypes.string,
	signalStrength: PropTypes.number
};

export default React.memo(DevicesTableRow);
